declare global {
    interface Window {
      dataLayer: any;
    }
  }

const trackEppWhatsCoveredTooltip = () => {
  const event = 'product_protection_whats_covered'

  const logData = {
    event,
  }

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(logData)
}

export default trackEppWhatsCoveredTooltip
